module.exports = __webpack_public_path__ + "img/p2.1a708041.png";